/**
 * Reports blocking dialog state to the main process for the CLI /status endpoint.
 * Watches sessions dialog and pro upgrade dialog stores.
 */

import { useEffect } from 'react';
import { useSessionsUIStore } from '../../sessions/store/uiStore';
import { useProUpgradePromptStore } from '../../../core/licensing/store/proUpgradePromptStore';

export function useAppStatusReporter() {
  const sessionsOpen = useSessionsUIStore((s) => s.showSessionsDialog);
  const proUpgradeOpen = useProUpgradePromptStore((s) => s.isOpen);

  useEffect(() => {
    let blockingDialog: string | null = null;
    if (sessionsOpen) {
      blockingDialog = 'sessions';
    } else if (proUpgradeOpen) {
      blockingDialog = 'pro-upgrade';
    }

    window.electronAPI?.mcpUiControl?.updateAppStatus({
      ready: !blockingDialog,
      blockingDialog,
    });
  }, [sessionsOpen, proUpgradeOpen]);

  // Report ready on mount (app loaded)
  useEffect(() => {
    window.electronAPI?.mcpUiControl?.updateAppStatus({ ready: true });
  }, []);
}
